import { render } from "./EditPageScore.vue?vue&type=template&id=43452065&scoped=true"
import script from "./EditPageScore.vue?vue&type=script&lang=js"
export * from "./EditPageScore.vue?vue&type=script&lang=js"

import "./EditPageScore.vue?vue&type=style&index=0&id=43452065&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43452065"]])

export default __exports__